import React, {FC, useState} from 'react';
import {Button, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, Spinner} from '../../../Components';

interface SwitchBackDialogProps {
  onCancel: () => void;
  onSwitchBack: (comments: string) => Promise<void>;
}

export const SwitchBackDialog: FC<SwitchBackDialogProps> = ({onCancel, onSwitchBack}) => {
  const [comments, setComments] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSwitchBack = () => {
    setSubmitting(true);
    onSwitchBack(comments.trim()).finally(() => setSubmitting(false));
  };

  return (
    <Dialog open onOpenChange={(open) => !open && !submitting && onCancel()}>
      <DialogContent>
        <DialogHeader>
          <DialogDescription />
          <DialogTitle>Why are you switching back?</DialogTitle>
        </DialogHeader>

        <textarea
          autoFocus
          rows={5}
          maxLength={4000}
          value={comments}
          placeholder="Optional"
          onChange={(e) => setComments(e.target.value)}
          className="w-full rounded-lg border border-gray-200 p-2.5 text-[13px] leading-relaxed focus:border-indigo-400 focus:outline-none"
        />

        <DialogFooter className="flex-row items-center justify-end gap-3">
          {submitting && <Spinner mode="dark" />}
          <Button size="small" variant="secondary" label="Cancel" onClick={onCancel} disabled={submitting} />
          <Button size="small" label="Switch back" onClick={handleSwitchBack} disabled={submitting} />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
